































































































































import { Component, Watch, Prop } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import { InstitutionsModule } from '@/store/Settings/InstitutionsModule';
import { AuthModule } from '@/store/Auth/AuthModule';
import CreatePaymentOrderRequest from '@/models/Accounts/Shared/PaymentOrders/CreatePaymentOrderRequest';
import ListUtils from '@/lib/listUtils';
import Payment from '@/models/Accounts/Shared/Payments/Payment';
import AccountType from '@/models/Shared/AccountType';
import Amount from '@/models/Shared/Amount';
import Payee from '@/models/Accounts/Shared/Payees/Payee';
import PayeeType from '@/models/Accounts/Shared/Payees/PayeeType';

@Component({ name: 'HawkAIPaymentOrderCreate' })
export default class extends SaascadaVueDialog {

    request: CreatePaymentOrderRequest = new CreatePaymentOrderRequest();
    amountAsNumber: number = 0;
    selectedPayee: Payee;
    paymentReference: string = '';
    expiresAtDateAsString: string = '';
    todaysDateAsString: string = new Date().toISOString().split('T')[0];

    @Prop({required: true})
    accountId: string;

    @Prop({required: true})
    currency: string;

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.request = new CreatePaymentOrderRequest();
            // Set date as a week in advance by default
            const expiresDate = new Date();
            expiresDate.setDate(expiresDate.getDate() + 7);
            this.expiresAtDateAsString = expiresDate.toISOString().slice(0, 10);
            // Set the country as the same as the Institutions country by default, if it exists
            if (this.institutionAddress) {
                this.request.customerAddress.country = this.institutionAddress.country;
            }
            // If there is only one scheme available then set it by default
            if (this.schemes.length === 1) {
                this.request.scheme = this.schemes[0];
            }
            // Get the latest payees when the modal opens
            await DepositAccountModule.getPayeesForDialog();
        }
    }

    get institutionAddress() {
        return InstitutionsModule.institutionLoggedIn.address;
    }

    get payees() {
        return DepositAccountModule.payeesForDialog;
    }

    get schemes() {
        // TODO: This is currently taken from the go backend hardcoded field for AvailablePaymentSchemes
        // But once this has been added to the main config the function can be swapped for just "institution.availablePaymentSchemes"
        return AuthModule.me.institution.config.availablePaymentSchemes;
    }

    get countryOptions() {
        return ListUtils.countryOptions();
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            // Create a new payment on the payments array
            this.request.payments.push(new Payment());
            this.request.payments[0].payee = new Payee();

            // Convert the amount into the right type
            const amount = new Amount();
            amount.amount = String(this.amountAsNumber);
            amount.currency = this.currency;

            // Apply values to the create request
            this.request.accountId = this.accountId;
            this.request.accountType = AccountType.Customer;
            this.request.payments[0].payee.accountNumber = this.selectedPayee.accountNumber;
            this.request.payments[0].payee.sortCode = this.selectedPayee.sortCode;
            this.request.payments[0].payee.name = this.selectedPayee.name;
            this.request.payments[0].payee.payeeType = PayeeType.IBAN;
            this.request.payments[0].amount = amount;
            this.request.payments[0].reference = this.paymentReference;
            this.request.expiresAtUtc = new Date(this.expiresAtDateAsString);

            // ----- ----- ----- ----- ----- -----
            // ----- HawkAI Specific changes -----
            // ----- ----- ----- ----- ----- -----
            // The line below is the only difference now, calls a different endpoint
            await DepositAccountModule.createHawkAIPaymentOrder(this.request);

            await DepositAccountModule.getPaymentOrders(1);
        }
    }

}
